import "semantic-ui/semantic.css"
import AuthenticatedView from "components/AuthenticatedView"
import ErrorModal from "components/ErrorModal"
import Loading from "components/Loading"
import React, {
  Component,
  lazy,
  Suspense,
  useState,
  useEffect,
  useCallback
} from "react"
import {
  BrowserRouter,
  Link,
  Route,
  Switch,
  withRouter,
  Redirect
} from "react-router-dom"
import { Dropdown } from "semantic-ui-react"
import { ErrorBoundary, Store, useStore } from "store"
import "./App.css"
import AppLayoutView from "./AppLayoutView"
import Methodology from "./Methodology"
import SigninWithToken from "./SigninWithToken"
import Signup from "./Signup"
import { AgreementsBanner } from "components/AppBanners"

const ResetPassword = lazy(() =>
  import("components/AuthenticatedView/ResetPassword")
)

export const AppMenu = ({ first_name, group_id }) => {
  const [subscription] = useStore("subscriptions", group_id)
  return (
    <Dropdown
      text={first_name}
      data-testid="userMenu"
      style={{ marginBottom: "12px" }}
    >
      <Dropdown.Menu>
        <Dropdown.Item
          as={Link}
          to="/household-profile"
          data-testid="householdProfileLink"
        >
          Household Profile
        </Dropdown.Item>
        <Dropdown.Item as={Link} to="/user-profile">
          User Settings
        </Dropdown.Item>
        {subscription &&
          subscription.plan_id !== null &&
          subscription.external_type === "stripe" && (
            <Dropdown.Item as={Link} to="/billing">
              Subscription/Billing
            </Dropdown.Item>
          )}
        {/* {subscription &&
          subscription.plan_id !== null &&
          subscription.external_type !== "stripe" && (
            <Dropdown.Item as={Link} to="/billing">
              Subscription/Billing
            </Dropdown.Item>
          )}
        {subscription &&
          process.env.REACT_APP_DEPLOY_ENV !== "production" &&
          subscription.external_type === "stripe" && (
            <Dropdown.Item
              as={Link}
              to={{
                pathname: "/billing-portal",
                state: { pathname: window.location.pathname }
              }}
            >
              Subscription/Billing
            </Dropdown.Item>
          )} */}
        <Dropdown.Item>
          <Methodology />
        </Dropdown.Item>
        <Dropdown.Item id="intercom">Help</Dropdown.Item>
        <Dropdown.Item as={Link} to="/signout">
          Sign Out
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

class HistoryListenerHandler extends Component {
  constructor(props) {
    super(props)
    this.unlisten = null
  }

  componentDidMount = () => {
    this.unlisten = this.props.history.listen((location, action) => {
      window.gtagSetPagePath && window.gtagSetPagePath(location.pathname)
    })
  }

  componentWillUnmount = () => {
    if (this.unlisten) {
      this.unlisten()
    }
  }

  render = () => {
    return this.props.children
  }
}

const HistoryListener = withRouter(props => (
  <HistoryListenerHandler {...props} />
))

const AppRoutes = () => {
  const [newAgreements] = useStore("newAgreements")
  const [showAgreementsBanner, toggleShowAgreementsBanner] = useState(null)
  const [
    nonExplicitAgreements,
    { acceptNonExplicitAgreements, signOut, signinWithToken, loadNewAgreements }
  ] = useStore("nonExplicitAgreements")

  useEffect(() => {
    if (
      showAgreementsBanner === null &&
      !newAgreements.length &&
      nonExplicitAgreements.length
    ) {
      toggleShowAgreementsBanner(true)
      const ids = nonExplicitAgreements.map(ag => ag.id)
      acceptNonExplicitAgreements(ids)
    }
  }, [
    newAgreements,
    nonExplicitAgreements,
    acceptNonExplicitAgreements,
    showAgreementsBanner
  ])

  const logoutUser = useCallback(
    async logout => {
      toggleShowAgreementsBanner(null)
      await signOut()
      logout()
    },
    [signOut]
  )

  return (
    <Switch>
      <Route
        path="/signup"
        render={({ location: { hash } }) => {
          return <Signup invite_code={hash.slice(1)} />
        }}
      />
      <Route
        path="/reset"
        render={({ location: { search } }) => {
          let email = ""
          try {
            email = new URLSearchParams(search).get("email") || ""
          } catch {
            email = search.split("email=")[1] || ""
          }
          return <ResetPassword email={decodeURIComponent(email)} />
        }}
      />
      <Route
        path="/signin"
        render={({ location }) => {
          const { hash, search } = location
          return (
            <SigninWithToken
              signinWithToken={signinWithToken}
              loadNewAgreements={loadNewAgreements}
              token={hash.length > 1 ? hash.slice(1) : null}
              path={search.length > 1 ? search.slice(1) : "/"}
            />
          )
        }}
      />
      <Route
        path="/"
        render={({ history, location }) => (
          <>
            {showAgreementsBanner && nonExplicitAgreements.length > 0 && (
              <div
                style={{
                  backgroundColor: "#4a4a4a",
                  width: "100%"
                }}
              >
                <AgreementsBanner
                  agreements={nonExplicitAgreements}
                  close={() => toggleShowAgreementsBanner(false)}
                />
              </div>
            )}
            <AuthenticatedView
              // getCurrentUser={() => currentUser}
              history={history}
              location={location}
              render={({ logout }) => {
                return <AppLayoutView logout={() => logoutUser(logout)} />
              }}
            />
          </>
        )}
      />
      <Redirect to="/signin" />
    </Switch>
  )
}

const App = () => {
  return (
    <Store>
      <Suspense fallback={<Loading />}>
        <BrowserRouter>
          <HistoryListener>
            <ErrorBoundary
              fallback={({ error, clearError }) => (
                <ErrorModal error={error} clearError={clearError} />
              )}
            >
              <AppRoutes />
            </ErrorBoundary>
          </HistoryListener>
        </BrowserRouter>
      </Suspense>
    </Store>
  )
}

export default App
